<template>
  <div class="mob-remove-table-fixed">
    <Card shadow>
      <Row class="sm-pc-w100">
        <Col :md="22">
          <Form :model="tableSearchForm" ref="tableSearchForm" inline :label-width="60" @submit.native.prevent>
            <FormItem label="模块名">
              <Input v-model="tableSearchForm.name" style="min-width: 200px" />
            </FormItem>
            <FormItem label="开发人员">
              <Select v-model="tableSearchForm.developers" placeholder="" filterable clearable transfer style="min-width: 200px">
                <Option v-for="item in userList" :key="item.id" :value="item.id">{{ item.name ? item.name : item.username }}</Option>
              </Select>
            </FormItem>
            <FormItem :label-width="0" class="mob-align-right">
              <Button type="primary" @click="getTableData()">搜索</Button>
              <Button style="margin-left: 8px" @click="clearSearchForm">重置</Button>
            </FormItem>
          </Form>
        </Col>
        <Col span="24" :md="2" class="align-right">
          <Button
            style="float: right;"
            @click="editModule()"
            type="primary"
            :style="{marginBottom: '10px'}"
            v-if="canEditModule"
            icon="md-add">添加模块</Button>
        </Col>
      </Row>
      <Alert v-if="listError" type="warning" show-icon>获取数据失败</Alert>
      <Table
        v-else
        stripe
        border
        highlight-row
        :loading="tableLoading"
        ref="table"
        :data="table.data"
        :columns="table.columns"></Table>
      <div style="margin: 10px 0; overflow: hidden;">
        <div style="float: left;">
          当前显示 {{ table.data.length }} 条记录，总共 {{ table.count }} 条记录
        </div>
        <div style="float: right;">
          <page
            :total="table.count"
            :current="table.page"
            :page-size="table.size"
            @on-change="getTableData"></page>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import { getModule, logicDeleteModule } from '@/api/workflow/project'
import { GetALLUsers } from '@/api/user'
import { getTenantRoles } from '@/api/workflow/tenant'
import moment from 'moment'
export default {
  data () {
    return {
      tableLoading: false,
      tableSearchForm: {
        name: '',
        applicant: '',
        developers: ''
      },
      table: {
        data: [],
        columns: [
          {
            title: '模块名',
            key: 'name',
            align: 'center',
            tooltip: true,
            minWidth: 150
          },
          {
            title: '所属项目',
            key: 'tenant_name',
            align: 'center',
            tooltip: true,
            minWidth: 150
          },
          {
            title: '开发人员',
            key: 'developers',
            align: 'center',
            tooltip: true,
            minWidth: 150,
            render: (h, params) => {
              let tags = []
              for (let i in params.row.developers) {
                const user = params.row.developers[i]
                tags.push(
                  h('Tag', {
                    attrs: {
                      color: 'blue'
                    }
                  }, user.name ? user.name : user.username)
                )
              }
              return h('div', tags)
            }
          },
          {
            title: '创建用户',
            key: 'created_user',
            align: 'center',
            tooltip: true,
            minWidth: 100,
            render: (h, params) => {
              return h('span', params.row.created_user.name ? params.row.created_user.name : params.row.created_user.username)
            }
          },
          {
            title: '创建时间',
            key: 'created_at',
            align: 'center',
            tooltip: true,
            minWidth: 150,
            render: (h, params) => {
              if (params.row.created_at) {
                return h('span', moment(params.row.created_at).format('YYYY-MM-DD HH:mm:ss'))
              } else {
                return ''
              }
            }
          },
          {
            title: '操作',
            align: 'center',
            fixed: 'right',
            width: 200,
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.$router.push({name: 'module_detail', params: { id: params.row.id }, query: { lastPage: this.table.page }})
                    }
                  }
                }, '详情'),
                h('Button', {
                  props: {
                    type: 'warning',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px',
                    display: this.canEditModule ? 'inline-block' : 'none'
                  },
                  on: {
                    click: () => {
                      this.editModule(params.row.id)
                    }
                  }
                }, '编辑'),
                h('Poptip', {
                  props: {
                    confirm: true,
                    transfer: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?'
                  },
                  style: {
                    display: this.canEditModule ? 'inline-block' : 'none'
                  },
                  on: {
                    'on-ok': () => {
                      this.delete(params.row)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                    }
                  }, '删除')
                ])
              ])
            }
          }
        ],
        count: 0,
        page: 1,
        size: 15
      },
      listError: false,
      userList: [],
      canEditModule: false
    }
  },
  created: function () {
    this.getTableData(this.$route.query.page ? parseInt(this.$route.query.page) : 1)
    this.getAllUserData()
    this.getTenantRolesData()
  },
  watch: {
    '$store.state.user.defaultTenant' () {
      this.getTenantRolesData()
    }
  },
  methods: {
    getTableData (value = 1) {
      this.table.page = value
      this.tableLoading = true
      let reqParams = {
        size: this.table.size,
        page: this.table.page,
        title: this.tableSearchForm.title,
        applicant: this.tableSearchForm.applicant
      }
      if (this.tableSearchForm.developers) {
        reqParams.developers = this.tableSearchForm.developers
      }
      getModule(reqParams).then(res => {
        let result = res.data
        this.table.data = result.results
        this.table.count = result.count
        this.tableLoading = false
        this.listError = false
      }).catch(res => {
        this.tableLoading = false
        console.log(res.response)
        this.listError = true
      })
    },
    editModule (id) {
      if (id) {
        this.$router.push({name: 'module_edit', params: {id: id}})
      } else {
        this.$router.push({name: 'module_add'})
      }
    },
    delete (row) {
      logicDeleteModule(row.id).then(res => {
        this.$Notice.success({ title: '操作成功！' })
        this.getTableData(this.table.page)
      }).catch(res => {
        console.log(res.response)
        if (res.request) {
          this.$Notice.error({
            title: '删除失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '删除失败！'
          })
        }
      })
    },
    clearSearchForm () {
      this.tableSearchForm = {
        name: '',
        applicant: '',
        developers: ''
      }
    },
    // 获取所有用户数据
    getAllUserData () {
      GetALLUsers().then(res => {
        this.userList = res.data
      })
    },
    // 获取租户角色信息
    getTenantRolesData () {
      if (this.$store.state.user.superuser) {
        this.canEditModule = true
      } else {
        getTenantRoles(this.$store.state.user.defaultTenant).then(res => {
          console.log(res.data)
          if (res.data) {
            this.canEditModule = res.data.can_edit_module
          } else {
            this.canEditModule = false
          }
        }).catch(res => {
          console.log(res.response)
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
